import { logger } from "@/modules/common/logging/logger";
import { ILoadCarrierService } from '@/modules/loadCarriers/service/ILoadCarrierService';

export class LoadCarrierServiceExceptionDecorator implements ILoadCarrierService {
  private readonly decoree: ILoadCarrierService;

  constructor(decoree: ILoadCarrierService) {
    this.decoree = decoree;
  }

  async loadLoadCarriers(): Promise<void> {
    try {
      await this.decoree.loadLoadCarriers();
    } catch (err) {
      this.logError('loadLoadCarriers', err);
      throw err;
    }
  }

  //
  // private utility methods
  //

  private logError(methodName: string, error: unknown): void {
    logger.error(`LoadCarrierService.${methodName} failed:`, error);
  }
}